export class UserCollateralCashflowClass {
  constructor(dealName, collateralMonth, scenarioName, vendor, collateralCashflow) {
    this.DealName = dealName;
    this.CollateralMonth = collateralMonth;
    this.ScenarioName = scenarioName
    this.Vendor = vendor
    this.CollateralCashflow = new CollateralCashflow(collateralCashflow.Balance, collateralCashflow.Interest, collateralCashflow.PassThru,
      collateralCashflow.ScheduledPrincipal, collateralCashflow.PrepaidPrincipal, collateralCashflow.Defaults, collateralCashflow.Losses,
      collateralCashflow.Recoveries, collateralCashflow.Delinquency, collateralCashflow.Libor)
  }
}

export class CollateralCashflow {
  constructor(balance, interest, passThru, scheduledPrincipal, prepaidPrincipal, defaults, losses, recoveries, delinquency, libor) {
    this.Balance = balance;
    this.Interest = interest;
    this.PassThru = passThru;
    this.ScheduledPrincipal = scheduledPrincipal;
    this.PrepaidPrincipal = prepaidPrincipal;
    this.Defaults = defaults;
    this.Losses = losses;
    this.Recoveries = recoveries;
    this.Delinquency = delinquency;
    this.Libor = libor;
  }
}
